// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__36Nsg","dragIcon":"SortableItem_dragIcon__16C0w","disabled":"SortableItem_disabled__2WcJO"};